import React from "react";
import FilterButton from "./FilterButton";
import FilterForm from "./FilterForm";

const SubmitFilters = (props) => {
	return props.context === "button" ? (
		<FilterButton {...props} />
	) : (
		<FilterForm {...props} />
	);
};

export default SubmitFilters;
